import React from 'react';
import './myprofileeducation.css';

const MyProfileEducation = ({ edudetails, handleEducationDelete }) => {
    const formatDate = (dateString) => {
        if (!dateString) return 'Present';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            year: 'numeric',
            month: 'short'
        });
    };

    // Check if edudetails exists and has items
    const hasEducation = edudetails && edudetails.length > 0;

    return (
        <div style={{ marginTop: '1.5rem' }}>
            {hasEducation ? (
                <div>
                    {edudetails.map((education, index) => (
                        <div key={education.education_id} style={{ marginBottom: '1rem' }}>
                            <div style={{ marginBottom: '1rem' }}>
                                <p>
                                    {education.title}
                                    <button 
                                        className='edudelbtn' 
                                        onClick={() => handleEducationDelete(education.education_id)}
                                        aria-label="Delete education entry"
                                    >
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                    <span style={{ float: 'right', fontWeight: '300' }}>
                                        {formatDate(education.start_date)} - {formatDate(education.end_date)}
                                    </span>
                                </p>
                                <p style={{ fontWeight: '300', margin: '0.5rem 0' }}>{education.school}</p>
                            </div>
                            {index !== edudetails.length - 1 && (
                                <hr style={{ 
                                    marginBottom: '1rem', 
                                    color: 'black', 
                                    height: '1px', 
                                    backgroundColor: 'black' 
                                }} />
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    <span>No Education Added</span>
                </div>
            )}
        </div>
    );
};

export default MyProfileEducation;